import styled from "styled-components";


const Gap = styled.div<{size?: string}>`
    height: ${props => props.size || '30%'};
`

export default Gap;